/* eslint-disable prettier/prettier */
import './App.scss';
import Header from './components/Header';
import Home from './components/Home';
import AboutUs from './components/About';
import Services from './components/Services';
import Team from './components/Team';
import Contact from './components/Contact';
import Footer from './components/Footer';
import { useEffect, useState } from 'react';
import ClassicHeader from './components/ClassicHeader';
import { commonConfig } from './config/commonConfig';
import TermsAndConditions from './components/TermsAndConditions';
import Disclaimer from './components/Disclaimer';
import PreLoader from './components/Preloader';
import { Tooltip } from './components/Tooltip';
import { IntlProvider } from 'react-intl';
import { setCookies, getCookies } from '../src/services/cookiesService';

import { getLang, messages } from './config/lang/helper';

function App() {
  const [lang, setLang] = useState(getLang());
  const [isAWare, setIsAWare] = useState(false);

  const updateCookies = (cookiesName, cookieValue) => {
    setCookies(cookiesName, cookieValue).then(() => setIsAWare(cookieValue));
  };

  const classicHeader = commonConfig.classicHeader;
  const darkTheme = commonConfig.darkTheme;

  const handleNavClick = (section) => {
    document.getElementById(section).scrollIntoView({ behavior: 'smooth' });
  };

  const [scrollTopVisible, setScrollTopVisible] = useState(false);
  const [isLoading, setisLoading] = useState(true);

  useEffect(() => {
    const checkScrollTop = () => {
      let scrollTopBtn = document.getElementById('back-to-top');

      if (scrollTopBtn) {
        if (
          document.body.scrollTop > 400 ||
          document.documentElement.scrollTop > 400
        ) {
          setScrollTopVisible(true);
        } else {
          setScrollTopVisible(false);
        }
      }
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', checkScrollTop);
    }
    const loadingTimeout = setTimeout(() => {
      setisLoading(false);
    }, 1000);

    if (getCookies('isCookiesAware')) {
      setIsAWare(true);
    }

    return () => {
      window.removeEventListener('scroll', checkScrollTop);
      clearTimeout(loadingTimeout);
    };
  }, []);

  const Content = () => (
    <div
      style={{ position: 'relative' }}
      className={classicHeader ? '' : 'side-header'}>
      {isLoading && <PreLoader></PreLoader>}

      <div id="main-wrapper">
        {classicHeader ? (
          <ClassicHeader
            lang={lang}
            setLang={setLang}
            handleNavClick={handleNavClick}
          />
        ) : (
          <Header
            lang={lang}
            setLang={setLang}
            handleNavClick={handleNavClick}
          />
        )}

        <div id="content" role="main">
          <Home
            lang={lang}
            classicHeader={classicHeader}
            darkTheme={darkTheme}
            handleNavClick={handleNavClick}
          />
          <AboutUs
            classicHeader={classicHeader}
            darkTheme={darkTheme}
            lang={lang}
          />
          <Services classicHeader={classicHeader} darkTheme={darkTheme} />
          <Team
            classicHeader={classicHeader}
            darkTheme={darkTheme}
            lang={lang}
          />
          <div className="section theme-blue-bg">
            <Contact
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              lang={lang}
            />
            <Footer
              classicHeader={classicHeader}
              darkTheme={darkTheme}
              handleNavClick={handleNavClick}
              isAWare={isAWare}
              updateCookies={updateCookies}
              setCookies={setCookies}
            />
          </div>
        </div>
      </div>

      {/* back to top */}
      <Tooltip text="Back to Top" placement="left">
        <span
          id="back-to-top"
          className="rounded-circle"
          style={{ display: scrollTopVisible ? 'inline' : 'none' }}
          onClick={() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}>
          <i className="fa fa-chevron-up"></i>
        </span>
      </Tooltip>

      <TermsAndConditions darkTheme={darkTheme}></TermsAndConditions>
      <Disclaimer darkTheme={darkTheme}></Disclaimer>
    </div>
  );

  return (
    <IntlProvider locale={lang} messages={messages[lang]}>
      <Content />
    </IntlProvider>
  );
}

export default App;
